module.exports = __webpack_public_path__ + "img/adolfo_services.51c257d5.png";